import Vue from 'vue';

export default {
  login(email, orderId, userInternalId) {
    const payload = {
      email,
      orderId,
    };
    if (userInternalId) payload.userInternalId = userInternalId;
    return Vue.prototype.axios
      .post('login', payload)
      .then((res) => res)
      .catch((error) => {
        throw error;
      });
  },
  preLogin(email, orderId) {
    return Vue.prototype.axios
      .get('pre-login', {
        params: {
          email,
          orderId,
        },
      })
      .then((res) => {
        const response = res.data;
        if (!response.success) throw new Error(`[${response.errorCode}] ${response.errorDescription}`);
        return response;
      })
      .catch((error) => {
        throw error;
      });
  },
  updateTermsService(email, superOrderId) {
    return Vue.prototype.axios
      .put(`terms-service?email=${email}&superOrderId=${superOrderId}&value=1&dealerId=${Vue.prototype.$session.get('dealerId')}`)
      .then((res) => res)
      .catch((error) => {
        throw error;
      });
  },
  updateNoticePrivacy(email, superOrderId, action, value) {
    return Vue.prototype.axios
      .put(`noticeOfPrivacy?email=${email}&superOrderId=${superOrderId}&action=${action}&value=${value}&dealerId=${Vue.prototype.$session.get('dealerId')}`)
      .then((res) => res)
      .catch((error) => {
        throw error;
      });
  },
};
